import Contract from "slotworks/utils/contract";
import HarleySpineSymbolBehaviour from "./spine-symbol-behaviour";


export default class IdleSpineSymbolBehaviour extends HarleySpineSymbolBehaviour {

    public win(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public cycle(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public highlight(...args: any[]): Contract<void> {
        return Contract.empty();
    }

    public stop(): Contract<void> {
        const s = "idle";
        this.symbol.setVisible(false);
        return this.animate(s, true, false);
    }
}
